// extracted by mini-css-extract-plugin
export default {"sponsors":"SponsorSection_sponsors__g0jrq"};